import React from 'react'
import { Link } from 'react-router-dom'
import {formatMs, calculaPrevision} from '../utils/time'
import '../scss/ResultadoList.css'
import CONFIG from '../config'
import MapaFavoritos from './MapaFavoritos'
import {lightenColorHex} from '../utils/color'

class ResultadoFavoritoList extends React.Component {
  //
  // ...
  constructor (props) {
    super(props)
    this.state = {
      time: 0
    }
  }

  componentDidMount () {
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 250)
  }

  componentWillUnmount () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  _buildMapaJSX (resultadosPrevision) {
    return <MapaFavoritos
      geoJson={this.props.geoJson}
      turfLine={this.props.turfLine} turfBounds={this.props.turfBounds}
      turfDistanceRelation={this.props.turfDistanceRelation}
      resultados={resultadosPrevision}
      controles={this.props.controles}
      sectores={this.props.sectores}
      competicion={this.props.competicion} />
  }

  render () {
    // console.info('redraw')
    const {sectores, controles, resultados, competicion, geoJson} = this.props

    if (resultados.length) {
      const resultadosPrevision = resultados.map((resultado) => {
        resultado.prevision = calculaPrevision(competicion, controles, sectores, resultado)
        return resultado
      })
      // console.info(resultadosPrevision)
      // Comprobamos si alguno de los resultados tiene previsión para mostrar el mapa:
      let mapaJSX = null
      if (geoJson && competicion.mapa_visible) {
        // console.info(this.props.geoJson)
        if (competicion.prevision_control_iniciar) {
          // si la previsión no comienza en salida no mostramos el mapa hasta
          // que alguno de los atletas sobrepase ese control.
          const verMapa = resultadosPrevision.filter((a) =>
            a.prevision.distancia > a.prevision.inicioDistancia
          )
          if (verMapa && verMapa.length) {
            let meta = controles.filter(a => a.tipo === 'META')
            if (meta && meta.length && meta[0].prevision) {
              mapaJSX = this._buildMapaJSX(resultadosPrevision)
            }
          }
        } else {
          // Si hay previsión de marca en meta
          let meta = controles.filter(a => a.tipo === 'META')
          if (meta && meta.length && meta[0].prevision) {
            mapaJSX = this._buildMapaJSX(resultadosPrevision)
          }
        }
      }

      let colorIndex = -1
      const colorValuesLength = CONFIG.COLORES_FAVORITOS.length

      return <div>
        {mapaJSX}
        <ul className='resultado-list'>
          {resultadosPrevision.map((resultado) => {
            colorIndex++
            const colorValue = CONFIG.COLORES_FAVORITOS[ colorIndex % colorValuesLength ]

            const control = resultado.prevision.controlUltimo
            let tiempo = null
            if (resultado.control_ultimo_id) {
              tiempo = resultado[ 'control_' + resultado.control_ultimo_id + '_tiempo' ]
            }

            let colorBarra = colorValue
            // console.info(resultado.prevision)
            if (resultado.prevision.sector_idx) {
              const map = JSON.parse(resultado.prevision.sector.mapa_geojson)
              const properties = map.features[0].properties
              if (properties.color) {
                colorBarra = properties.color
              }
            }

            return (
              <li key={resultado.dorsal} className='resultado-list__row'>
                <Link to={`/competicion/${competicion.id}/dorsal/${resultado.dorsal}`}>
                  <div className='resultado-item'>
                    <div className='resultado-item__puesto' style={{ backgroundColor: colorValue }}>
                      {resultado.nombre[ 0 ].toUpperCase()}
                      {resultado.apellidos ? (
                        resultado.apellidos[ 0 ].toUpperCase()
                      ) : (
                        ''
                      )}
                    </div>
                    {resultado.preload ? (
                      <div className='resultado-item__nombre--preload' />
                    ) : (
                      <div className='resultado-item__nombre'>
                        {resultado.nombre} {resultado.apellidos}
                      </div>
                    )}
                    {resultado.preload ? (
                      <div className='resultado-item__info--preload' />
                    ) : (
                      <div className='resultado-item__info'>
                        Dorsal <strong>{resultado.dorsal}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
                        {control ? (
                          <span>
                            {control.tipo === 'META' ? (
                              <span>Carrera finalizada</span>
                            ) : (
                              <span>
                                {formatMs(tiempo)}
                                &nbsp; en &nbsp;
                                {control.nombre}
                              </span>
                            )}
                          </span>
                        ) : (
                          <span>Todavía sin resultados...</span>
                        )}
                      </div>
                    )}
                    {control && control.tipo === 'META' ? (
                      <div>
                        {resultado.descalificado ? (
                          <div className='resultado-item__tiempo'>DESCAL.</div>
                        ) : (
                          <div className='resultado-item__tiempo'>
                            {formatMs(tiempo)}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className='resultado-item__tiempo'>
                        {resultado.prevision.tiempo !== null ? (
                          <span className='resultado-item__prevision'>
                            {formatMs(resultado.prevision.tiempo)}
                            {resultado.prevision.sector ? (
                              <small>prev. SECTOR</small>
                            ) : (
                              <small>(previsión)</small>
                            )}
                          </span>
                        ) : (
                          <span>---</span>
                        )}
                      </div>
                    )}
                    {resultado.prevision.distancia !== null && (
                      <div
                        className={'resultado-item__progreso'}
                        style={{backgroundColor: lightenColorHex(colorBarra.replace('#', ''), 75)}}>
                        <div
                          className={'resultado-item__progreso--completado'}
                          style={{ width: resultado.prevision.porcentaje + '%', backgroundColor: colorBarra }} />
                      </div>
                    )}
                  </div>
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    } else {
      if (this.props.geoJson && this.props.geoJson.length) {
        let mapaJSX = this._buildMapaJSX([])
        return mapaJSX
      }
    }
    return null
  }
}

export default ResultadoFavoritoList



// WEBPACK FOOTER //
// ./src/components/ResultadoFavoritosList.js